import React from 'react';
import { ChevronLeft, Check, Star, Sparkles, Shield, CreditCard } from 'lucide-react';

const PricingPage = ({ onBack }) => {
  return (
    <div className="min-h-screen bg-slate-50 py-12 px-4 font-sans no-print flex items-center justify-center">
      <div className="max-w-6xl w-full mx-auto">
        
        {/* ÜST BİLGİ - BAŞLIK */}
        <button onClick={onBack} className="mb-8 flex items-center text-sm font-bold text-slate-500 hover:text-purple-600 transition-colors">
          <ChevronLeft className="h-4 w-4 mr-1"/> Panele Dön
        </button>
        
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-black text-slate-900 mb-4 tracking-tight">
            Yapay Zeka Gücünü <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-blue-500">Sınırlarına Kadar Kullanın.</span>
          </h1>
          <p className="text-lg text-slate-500 max-w-2xl mx-auto">
            Öğrencilerinizi saniyeler içinde analiz edin, velilere profesyonel raporlar sunun. Sınırlara takılmadan, özgürce çalışın.
          </p>
        </div>

        {/* PAKETLER KARTLARI */}
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto items-stretch">
          
          {/* ÜCRETSİZ PAKET */}
          <div className="bg-white rounded-3xl p-8 border border-slate-200 shadow-sm relative overflow-hidden flex flex-col h-full">
            <h3 className="text-2xl font-bold text-slate-800 mb-2">Başlangıç Planı</h3>
            <p className="text-slate-500 mb-6 h-12">Sistemi denemek ve temel özelliklerini keşfetmek isteyen uzmanlar için.</p>
            <div className="text-4xl font-black text-slate-900 mb-8">Ücretsiz</div>
            
            <ul className="space-y-4 mb-8 flex-1">
              <li className="flex items-start"><Check className="h-5 w-5 text-emerald-500 mr-3 shrink-0"/> <span className="text-slate-600">Her test için sadece 5 öğrenci limiti</span></li>
              <li className="flex items-start"><Check className="h-5 w-5 text-emerald-500 mr-3 shrink-0"/> <span className="text-slate-600">Standart Yapay Zeka Yorumlaması</span></li>
              <li className="flex items-start"><Check className="h-5 w-5 text-emerald-500 mr-3 shrink-0"/> <span className="text-slate-600">Bireysel PDF Çıktısı</span></li>
              <li className="flex items-start text-slate-400"><span className="mr-3 block w-5 text-center font-bold">-</span> Toplu Sınıf ve Okul Analizi yok</li>
              <li className="flex items-start text-slate-400"><span className="mr-3 block w-5 text-center font-bold">-</span> Gelişmiş Terzi İşi Promptlar yok</li>
            </ul>
            
            <button disabled className="w-full py-4 mt-auto bg-slate-100 text-slate-400 rounded-xl font-bold cursor-not-allowed">
              Şu Anki Planınız
            </button>
          </div>

          {/* PREMIUM PAKET */}
          <div className="bg-gradient-to-b from-purple-900 to-indigo-900 rounded-3xl p-8 border border-purple-700 shadow-2xl relative overflow-hidden flex flex-col h-full transform md:-translate-y-4">
            
            {/* Parlama Efekti */}
            <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-gradient-to-br from-pink-500 to-purple-500 rounded-full blur-2xl opacity-50"></div>
            
            <div className="bg-gradient-to-r from-pink-500 to-orange-400 text-white text-xs font-black px-3 py-1 rounded-full absolute top-6 right-6 uppercase tracking-wider flex items-center shadow-lg">
              <Star className="h-3 w-3 mr-1 fill-white"/> En Popüler
            </div>

            <h3 className="text-2xl font-bold text-white mb-2">Premium Sınırsız</h3>
            <p className="text-purple-200 mb-6 h-12">Yüzlerce öğrenciyi tek tıkla analiz eden, zamandan tasarruf eden profesyoneller için.</p>
            
          {/* EYLÜL AYI KAMPANYA BLOKU */}
<div className="mb-6 relative z-10">
  <div className="flex items-center gap-2 mb-1">
    <span className="text-lg font-bold text-purple-300/60 line-through decoration-rose-500/80 decoration-2">
      1.000 ₺
    </span>

    <span className="bg-gradient-to-r from-emerald-500 to-teal-500 text-white px-2.5 py-0.5 rounded-full text-[10px] font-black tracking-widest shadow-md animate-pulse">
      EYLÜL AYINA ÖZEL
    </span>
  </div>

  <div className="flex items-end">
    <span className="text-5xl font-black text-white tracking-tighter">750</span>
    <span className="text-2xl font-bold text-purple-200 ml-1 mb-1">₺</span>
    <span className="text-sm font-bold text-purple-300 ml-1 mb-1.5">/ Yıllık</span>
  </div>

  <p className="text-xs font-bold text-pink-300 mt-2">
    ✨ Eylül boyunca %25 indirimle 1 yıllık Premium erişim.
  </p>
</div>

            <p className="text-sm text-purple-300 mb-8 font-medium">1 Yıllık Sınırsız Profesyonel Lisans</p>
            
            <ul className="space-y-4 mb-8 flex-1">
              <li className="flex items-start"><Check className="h-5 w-5 text-pink-400 mr-3 shrink-0"/> <span className="text-white font-medium">Sınırsız Öğrenci ve Test Ekleme</span></li>
              <li className="flex items-start"><Check className="h-5 w-5 text-pink-400 mr-3 shrink-0"/> <span className="text-white">Tek Tıkla "Toplu Sınıf Analizi"</span></li>
              <li className="flex items-start"><Check className="h-5 w-5 text-pink-400 mr-3 shrink-0"/> <span className="text-white">Gemini AI ile Kesintisiz Hız</span></li>
              <li className="flex items-start"><Check className="h-5 w-5 text-pink-400 mr-3 shrink-0"/> <span className="text-white">Sınırsız PDF ve Excel Arşivi</span></li>
              <li className="flex items-start"><Check className="h-5 w-5 text-pink-400 mr-3 shrink-0"/> <span className="text-white">AI İçerik Atölyesi</span></li>
              <li className="flex items-start"><Check className="h-5 w-5 text-pink-400 mr-3 shrink-0"/> <span className="text-white">Öncelikli Teknik Destek</span></li>
            </ul>
            
            {/* SİHİRLİ SATIN ALMA BUTONU (LİNK BURADA) */}
            <a 
              href="https://shopier.com/Rehber360PDR/45705716" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-full py-4 mt-auto bg-gradient-to-r from-pink-500 to-orange-400 hover:from-pink-600 hover:to-orange-500 text-white rounded-xl font-bold flex justify-center items-center shadow-lg transition-all group"
            >
              <CreditCard className="h-5 w-5 mr-2 group-hover:scale-110 transition-transform"/> Kredi Kartı ile Hemen Başla
            </a>
            
            <div className="mt-4 flex flex-col items-center justify-center gap-1.5 text-center">
              <div className="flex items-center text-purple-200/90 text-[12px] font-medium mb-1">
                <Shield className="h-4 w-4 mr-1.5" />
                <span><strong>Shopier</strong> güvencesiyle 12 aya varan taksit imkanı</span>
              </div>
              <div className="text-white/80 text-[10px] bg-white/10 px-4 py-2 rounded-lg border border-white/20 w-full">
                ⚡ Ödemeniz tamamlandıktan sonra, hesabınız satın alırken kullandığınız e-posta adresi üzerinden <strong>24 saat içerisinde</strong> Premium statüsüne yükseltilecektir.
              </div>
            </div>

          </div>

        </div>

        {/* GÜVEN DAMGASI */}
        <div className="mt-12 flex justify-center items-center space-x-2 text-slate-500 text-sm">
          <Shield className="h-5 w-5 text-emerald-500"/>
          <span>Ödemeleriniz ve verileriniz %100 güvence altındadır.</span>
        </div>

      </div>
    </div>
  );
};

export default PricingPage;